import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PurchaseOrdersItem } from "../PurchaseorderItem/PurchaseOrdersItem";
import styles from "./purchaseOrderList.module.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { IMAGE_PATH } from "../../../Utils/variables";
export const PurchaseOrderList = ({
  handleDetail,
  getFilterData,
  searched,
}) => {
  const [initialLoading, setinitialLoading] = useState(true);
  const [value, setValue] = useState([]);
  const [activeTabId, setActiveTab] = useState();
  const [count, setTotalCount] = useState("0");
  const [pageNumber, setPageNumber] = useState(0);
  const { isLogin, vendorId } = useSelector((state) => state.auth);
  let pageLimit = 2;
  const onClickTabItem = (tabId) => {
    setActiveTab(tabId);
  };
  const LeftCardDataLoad = (
    pageLimit,
    Communities,
    manageBy,
    closingOnstart,
    closingOnend,
    postedOnstart,
    postedOnend,
    searched_query
  ) => {
    // let pageNo = (((value.length / pageLimit) + 1)-1);
    setPageNumber(pageNumber + pageLimit);
    fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/show", {
      method: "POST",
      body: JSON.stringify({
        vendor_id: vendorId,
        // page_no: pageNumber,
        // record_per_page: pageLimit,
        communities: Communities,
        manageBy: manageBy,
        closingOnstart: closingOnstart,
        closingOnend: closingOnend,
        postedOnstart: postedOnstart,
        postedOnend: postedOnend,
        search_query: searched_query,
      }),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((result) => {
        setTotalCount(result.response.count);

        if (result.response.data.length === 0) {
          handleDetail("");
          setActiveTab("");
          setValue([]);
        } else {
          // setValue([...value, ...result.response.data]);
          setValue(result.response.data);
          handleDetail(result.response.data[0].po_id, result.response.data[0].community_id);
          setActiveTab(result.response.data[0].po_id);
        }
        setinitialLoading(false);
      })
      .catch((err) => {
        setinitialLoading(false);
      });
  };
  const fetchMore = () => {
    if (value.length < count) {
      LeftCardDataLoad(
        pageLimit,
        getFilterData.Communities,
        getFilterData.manageBy,
        getFilterData.closingOnstart,
        getFilterData.closingOnend,
        getFilterData.postedOnstart,
        getFilterData.postedOnend,
        searched
      );
    }
  };
  useEffect(() => {
    LeftCardDataLoad(
      pageLimit,
      getFilterData.Communities,
      getFilterData.manageBy,
      getFilterData.closingOnstart,
      getFilterData.closingOnend,
      getFilterData.postedOnstart,
      getFilterData.postedOnend,
      searched
    );
  }, [searched]);
  useEffect(() => {
    LeftCardDataLoad(
      pageLimit,
      getFilterData.Communities,
      getFilterData.manageBy,
      getFilterData.closingOnstart,
      getFilterData.closingOnend,
      getFilterData.postedOnstart,
      getFilterData.postedOnend
    );
  }, [getFilterData]);

  return (
    <>
      <div>
        <div className={styles.topPOList}>
          <div className={styles.topNavPO}>
            <h1>Purchase Orders List</h1>
            <p>{count} ACTIVE</p>
          </div>
          {value && value.length > 0 ? (
            <div className={styles.middlePOList} id="scrollableDiv">
              {/* <InfiniteScroll
                dataLength={value.length}
                next={fetchMore}
                hasMore={value.length < count}
                loader={<h4>Loading...</h4>}
                scrollableTarget="scrollableDiv"
              > */}
              {value.map((item) => {
                return (
                  <PurchaseOrdersItem
                    key={item.po_id}
                    handleDetail={handleDetail}
                    onClickTabItem={onClickTabItem}
                    {...item}
                    activeTabId={activeTabId}
                  />
                );
              })}
              {/* </InfiniteScroll> */}
            </div>
          ) : (
            <div className={styles.middlePOList}>
              <div className="noDataToShowList">
                {initialLoading ? (
                  <i
                    className="fa fa-spinner fa-spin "
                    style={{ color: "var(--BaseDarkColor)", fontSize: "40px" }}
                  ></i>
                ) : (
                  <img src={IMAGE_PATH + "poList.svg"} alt="" />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
